module.exports = __webpack_public_path__ + "img/participant-select-mobile-ru.51e4864b.jpg";